import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  buttonsContainer: {
    height: 48,
    width: 470,
    borderRadius: 4,
    display: "flex",
    flexDirection: "row",
  },
  leftButton: {
    height: 48,
    width: 235,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  rightButton: {
    height: 48,
    width: 235,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  bonusCard: {
    height: 28,
    width: 163,
    backgroundColor: theme.palette.main.primary.o,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginLeft: 8,
  },
  bonusCardIconContainer: {
    height: 16,
    width: 16,
    borderRadius: 8,
    backgroundColor: theme.palette.main.secondary.o,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  bonusCardIcon: {
    color: theme.palette.main.primary.o,
    fontSize: 16,
  },
  bonusCardText: {
    color: theme.palette.natural.t4,
    fontSize: 14,
    fontWeight: "400",
    marginLeft: 10,
  },
}));
